// Learn TypeScript:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/life-cycle-callbacks.html

import utilsModel from "../../../../../engines/libs/utilsModel";
import O1HD from "../../../../../engines/gameEngine";
import { MessageEventKind } from "../../../../define/MessageEventKind";
import NormalGameManager from "../../../manager/NormalGameManager";
import SettleLawsuitResultLayer from "./SettleLawsuitResultLayer";

const {ccclass, property} = cc._decorator;

@ccclass
export default class SettleLawsuitLoseLayer extends SettleLawsuitResultLayer {

    /** 金币变化值 */
    private goldChangeNum = 0;

    // LIFE-CYCLE CALLBACKS:

    // onLoad () {}

    initShow () {
        this.labelGold.string = '-0';
        this.labelReputation.string = '-0';
    }

    onClickRecome() {
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        utilsModel.loadAndShowVideoAdTrans(()=>{
                this.toRecome();
            }, ()=>{

            }
            , null
            , "翻案重来观看广告"
        );
    }

    /**
     * 重来
     */
    toRecome() {
        let gameManager = NormalGameManager._instance;
        if (this.goldChangeNum != 0) {
            O1HD.getServices().userSrv.setCoins(-this.goldChangeNum, true);
        }
        gameManager.setGameData(
            {m_reputation: this.oriReputation, m_officialLv: this.oriOfficialLv}
            , false
        );
        this.destroyNode();
        this._carryData.parent.againStart();
    }

    onClickClose() {
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        super.onClickClose();
        O1HD.emit(MessageEventKind.EventName.UPDATE_EXP);
        O1HD.emit(MessageEventKind.EventName.LEVEL_JUDGE);
    }

    // update (dt) {}
}
